<style scoped>
.checkin_information_attendance {
  width: 380px;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
}
.checkin_information_attendance_top {
  width: 100%;
  height: 69px;
  line-height: 69px;
  padding-left: 20px;
  color: rgba(0, 0, 0, 0.65);
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
}
.checkin_information_attendance_content {
  flex: 1;
  overflow-y: auto;
  width: 327px;
  max-height: 470px;
  margin: 0 auto;
}
.singe2 {
  width: 100%;
  height: 42px;
}
.checkin_information_attendance_single {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 14px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid #e8e8e8;
}
::v-deep .el-input__icon {
  line-height: 1.5rem;
}
.checkin_information_attendance_text {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ing {
  position: relative;
}
.ing::after {
  content: "";
  background: #f0142f;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.end {
  position: relative;
}
.end::after {
  content: "";
  background: rgba(0, 0, 0, 0.4);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.no-more{
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(115, 113, 113);
  height: 300px;
}
</style>

<template>
  <div class="checkin_information_attendance">
    <div class="checkin_information_attendance_top">事件申请</div>
    <div class="checkin_information_attendance_content">
      <div v-if="attendanceList && attendanceList.length>0" v-for="item in attendanceList" :key="item.id" class="singe2">
        <div
            v-if="item.umsUser"
            :class="[
                  'checkin_information_attendance_single',
                  item.status == 0 ? 'ing' : 'end',
                ]"
        >
          <div class="checkin_information_attendance_text">
            {{ item.umsUser.name }}提交的{{
              typeofAttendance(item.type)
            }}申请
          </div>
          <div>{{ item.createTime }}</div>
        </div>
      </div>
      <div v-if="!(attendanceList && attendanceList.length>0)" class="no-more">暂无数据...</div>
    </div>
  </div>
</template>


<script>
import {BmsApplyApi} from '@/api/server/bmsApply';
export default {
  components: {},
  data() {
    return {
      attendanceList: [],
      queryForm: {
        pageNum: 1,
        pageSize: 30
      },
      applyInterval: null
    };
  },
  created() {

  },
  mounted() {
     this.getAttendance();
     this.applyInterval = setInterval(() => {
       this.getAttendance();
     },60000);
  },
  destroyed() {
    this.applyInterval && clearInterval(this.applyInterval);
    this.applyInterval = null;
  },
  methods: {
    getAttendance() {
      BmsApplyApi.queryApplyList(this.queryForm).then((res) => {
        if (res.code == 200) {
          this.attendanceList = res.data.list;
        }
      })
    },
    typeofAttendance(type) {
      switch (type) {
        case 0:
          return "加班";
        case 1:
          return "补卡";
        case 2:
          return "请假";
        case 3:
          return "出差";
        case 4:
          return "外出";
      }
    }
  }
};
</script>